import $ from "jquery";

export default class CalcForm {
  constructor() {
    $(document).ready(function () {
      $("#CalcFormSubmit").removeAttr("disabled");
    });

    $("#dachgrosse, #strombedarf-2, #dachtyp-2, #begrunt, #tarif").on(
      "change",
      function () {
        if (
          $("#dachgrosse").val() &&
          $("#strombedarf-2").val() &&
          $("#dachtyp-2").val() &&
          $("#tarif").val()
        ) {
          calcSendToForm();
        }
      }
    );

    document.addEventListener(
      "wpcf7mailsent",
      (event) => {
        const formElement = document.querySelector("#calcForm .wpcf7");
        if (formElement) {
          const formId = formElement.id.match(/wpcf7-f(\d+)-/);
          if (formId && formId[1]) {
            if (event.detail.contactFormId == formId[1]) {
              this.performCalculations();
            }
          }
        }
      },
      false
    );

    this.performCalculations = function () {
      console.log("performCalculations");
      $("#overlay-text-1").hide();
      $("#overlay-text-2").show();
      $("#calc-spinner").show();
      var dachGrosse = $("#dachgrosse").val();
      var strombedarf = $("#strombedarf-2").val();
      var dachTyp = $("#dachtyp-2").val();
      var begrunt = $("#begrunt:checked").val();
      var tarif = $("#tarif").val();
      var energiebedarf_flachdach = dachGrosse / 7;
      var energiebedarf_schraegdach = dachGrosse / 5;
      $("#result-energiebedarf").text(
        parseInt(strombedarf).toLocaleString("de-CH")
      );
      if (dachTyp == "Flachdach" || dachTyp == "Toit plat") {
        var result_solaranlage = energiebedarf_flachdach;
        $("#result-solaranlage").text(
          parseInt(energiebedarf_flachdach).toLocaleString("de-CH")
        );
      }
      if (dachTyp == "Schraegdach" || dachTyp == "Toiture en pente") {
        var result_solaranlage = energiebedarf_schraegdach;
        $("#result-solaranlage").text(
          parseInt(energiebedarf_schraegdach).toLocaleString("de-CH")
        );
      }

      $("#result-solahresertrag").text(
        parseInt(result_solaranlage * 950).toLocaleString("de-CH")
      );
      var solarstrom_calculated =
        0.23 * (strombedarf / (result_solaranlage * 950)) + 0.05;
      if (solarstrom_calculated > 1) {
        var result_solarstrom = 1;
        $("#result-solarstrom").text(1);
      }
      if (solarstrom_calculated <= 1) {
        var result_solarstrom =
          solarstrom_calculated * (result_solaranlage * 950);
        $("#result-solarstrom").text(
          parseInt(result_solarstrom).toLocaleString("de-CH")
        );
      }
      var oppKosten = (tarif * result_solarstrom) / 100;
      var contractingpreis = 14 - result_solaranlage * 0.004;
      if (contractingpreis < 6) {
        contractingpreis = 6;
      }
      var kosten = (result_solarstrom * contractingpreis) / 100;
      $("#result-energiekosten").text(
        parseInt(oppKosten - kosten).toLocaleString("de-CH")
      );
      $("#result-ersparnis").text(
        parseInt((oppKosten - kosten) * 23.75).toLocaleString("de-CH")
      );
      $("#result-chf").text($("#result-energiekosten").text());

      setTimeout(() => {
        $("#calc-overlay").hide();
      }, 2000);
    };

    function calcSendToForm() {
      console.log("calcSendToForm INSIDE");
      var dachGrosse = $("#dachgrosse").val();
      var strombedarf = $("#strombedarf-2").val();
      var dachTyp = $("#dachtyp-2").val();
      var begrunt = $("#begrunt:checked").val();
      var tarif = $("#tarif").val();
      var energiebedarf_flachdach = dachGrosse / 7;
      var energiebedarf_schraegdach = dachGrosse / 5;
      $("#result-energiebedarf-2").val(parseInt(strombedarf));
      if (dachTyp == "Flachdach" || dachTyp == "Toit plat") {
        var result_solaranlage = energiebedarf_flachdach;
        $("#result-solaranlage-2").val(parseInt(energiebedarf_flachdach));
      }
      if (dachTyp == "Schraegdach" || dachTyp == "Toiture en pente") {
        var result_solaranlage = energiebedarf_schraegdach;
        $("#result-solaranlage-2").val(parseInt(energiebedarf_schraegdach));
      }

      $("#result-solahresertrag-2").val(parseInt(result_solaranlage * 950));
      var solarstrom_calculated =
        0.23 * (strombedarf / (result_solaranlage * 950)) + 0.05;
      if (solarstrom_calculated > 1) {
        var result_solarstrom = 1;
        $("#result-solarstrom-2").val(1);
      }
      if (solarstrom_calculated <= 1) {
        var result_solarstrom =
          solarstrom_calculated * (result_solaranlage * 950);
        $("#result-solarstrom-2").val(parseInt(result_solarstrom));
      }
      var oppKosten = (tarif * result_solarstrom) / 100;
      var contractingpreis = 14 - result_solaranlage * 0.004;
      if (contractingpreis < 6) {
        contractingpreis = 6;
      }
      var kosten = (result_solarstrom * contractingpreis) / 100;
      $("#result-energiekosten-2").val(parseInt(oppKosten - kosten));
      $("#result-ersparnis-2").val(parseInt((oppKosten - kosten) * 23.75));
      $("#result-chf-2").val($("#result-energiekosten-2").val());
    }
  }
}
